"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtnFilterClick = void 0;
var SampleNature = require("./AanvraagAlgemeneInfo/SampleNature");
var SampleNature_1 = require("./AanvraagAlgemeneInfo/SampleNature");
var Algemeen = require("./Algemeen");
var $TbxConfirmationDateFrom;
var $TbxConfirmationDateTo;
//$(document).ready(function () {
//    Init();
//});
function Init() {
    SampleNature.InitSampleNature(false);
    SampleNature_1.cbSampleNature.selectedValue = $('#ctl00_cphBody_hfSampleNatureValue').val();
    $TbxConfirmationDateFrom = $('#ctl00_cphBody_TbxConfirmationDateFrom');
    $TbxConfirmationDateTo = $('#ctl00_cphBody_TbxConfirmationDateTo');
    Algemeen.AddDatepicker($TbxConfirmationDateFrom, null, null);
    Algemeen.AddDatepicker($TbxConfirmationDateTo, null, null);
}
function BtnFilterClick() {
    $('#ctl00_cphBody_hfSampleNatureValue').val(SampleNature_1.cbSampleNature.selectedValue);
    return true;
}
exports.BtnFilterClick = BtnFilterClick;
